import React from 'react';

const FeeDetails = ({
    academicYear,
    totalFee,
    summary,
}) => {
    if (!summary) {
        return (
            <div className="bg-white rounded-2xl shadow-lg p-8 text-center border border-[#0d4f5c]/20">
                <div className="w-20 h-20 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
                    <svg
                        className="w-12 h-12 text-gray-400"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                    >
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                        />
                    </svg>
                </div>

                <h3 className="text-xl font-bold text-gray-800 mb-2">
                    No Fees to Display
                </h3>

                <p className="text-gray-500">
                    No fee summary is available.
                </p>
            </div>
        );
    }

    const feeRows = [
        {
            label: 'Regular Fee',
            amount: Number(summary.regularFeeAmt || 0),
            color: 'bg-green-100 text-green-800',
        },
        {
            label: 'Arrear Fee',
            amount: Number(summary.arrearFeeAmt || 0),
            color: 'bg-red-100 text-red-800',
        },
        {
            label: 'Other Fee',
            amount: Number(summary.otherFeeAmt || 0),
            color: 'bg-blue-100 text-blue-800',
        },
        {
            label: 'Fine Fee',
            amount: Number(summary.fineFeeAmt || 0),
            color: 'bg-orange-100 text-orange-800',
        },
    ];

    const displayTotal = Number(summary.totalFee || totalFee || 0);

    return (
        <>
            {/* Fee Info Bar */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">

                {/* Academic Year */}
                <div className="bg-gradient-to-r from-[#0d4f5c] to-[#1a7a8a] rounded-xl shadow-md p-4 flex items-center gap-3">
                    <svg
                        className="w-6 h-6 text-white"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                    >
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                        />
                    </svg>

                    <div>
                        <p className="text-xs text-white/80">
                            Academic Year
                        </p>

                        <p className="font-medium text-white">
                            {academicYear || 'N/A'}
                        </p>
                    </div>
                </div>

                {/* Total Fee */}
                <div className="bg-[#0d4f5c]/10 rounded-xl shadow-md p-4 border-2 border-[#0d4f5c]/30 flex items-center gap-3">
                    <div className="bg-gradient-to-r from-[#0d4f5c] to-[#1a7a8a] rounded-full w-12 h-12 flex items-center justify-center">
                        <span className="text-white font-bold text-lg">
                            ₹
                        </span>
                    </div>

                    <div>
                        <p className="text-xs text-[#0d4f5c] font-medium">
                            Total Amount
                        </p>

                        <p className="text-2xl font-bold text-[#0d4f5c]">
                            ₹{displayTotal.toLocaleString('en-IN')}
                        </p>
                    </div>
                </div>
            </div>

            {/* Fee Summary */}
            <div className="bg-white rounded-2xl shadow-lg overflow-hidden border border-[#0d4f5c]/20">

                {/* Header */}
                <div className="bg-gradient-to-r from-[#0d4f5c] to-[#1a7a8a] text-white p-4">
                    <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-2">

                        <div>
                            <h3 className="text-lg font-bold">
                                Exam Fees Statement
                            </h3>

                            <p className="text-xs opacity-90">
                                Fee Summary
                            </p>
                        </div>

                        <div className="bg-white/20 px-4 py-2 rounded-lg text-sm font-semibold">
                            Total: ₹{displayTotal.toLocaleString('en-IN')}
                        </div>

                    </div>
                </div>

                {/* Table */}
                <div className="p-4 md:p-6">
                    <div className="overflow-x-auto">

                        <table className="w-full border-collapse">

                            <thead>
                                <tr className="bg-[#0d4f5c]/10">

                                    <th className="border border-[#0d4f5c]/20 px-4 py-3 text-left text-sm font-semibold text-gray-700">
                                        S.No.
                                    </th>

                                    <th className="border border-[#0d4f5c]/20 px-4 py-3 text-left text-sm font-semibold text-gray-700">
                                        Fee Type
                                    </th>

                                    <th className="border border-[#0d4f5c]/20 px-4 py-3 text-right text-sm font-semibold text-gray-700">
                                        Amount (₹)
                                    </th>

                                </tr>
                            </thead>

                            <tbody>

                                {feeRows.map((fee, index) => (
                                    <tr
                                        key={fee.label}
                                        className="hover:bg-[#0d4f5c]/5 transition-colors"
                                    >

                                        <td className="border border-[#0d4f5c]/20 px-4 py-3 text-sm text-gray-700">
                                            {index + 1}
                                        </td>

                                        <td className="border border-[#0d4f5c]/20 px-4 py-3 text-sm">
                                            <span
                                                className={`inline-flex px-3 py-1 rounded-full text-xs font-semibold ${fee.color}`}
                                            >
                                                {fee.label}
                                            </span>
                                        </td>

                                        <td className="border border-[#0d4f5c]/20 px-4 py-3 text-sm text-right font-semibold text-gray-700">
                                            ₹{fee.amount.toLocaleString('en-IN')}
                                        </td>

                                    </tr>
                                ))}

                                {/* Total */}
                                <tr className="bg-[#0d4f5c]/10 font-bold">

                                    <td
                                        colSpan="2"
                                        className="border border-[#0d4f5c]/20 px-4 py-3 text-right text-sm text-gray-700"
                                    >
                                        Total Amount
                                    </td>

                                    <td className="border border-[#0d4f5c]/20 px-4 py-3 text-right text-[#0d4f5c] text-lg">
                                        ₹{displayTotal.toLocaleString('en-IN')}
                                    </td>

                                </tr>

                            </tbody>

                        </table>

                    </div>
                </div>
            </div>
        </>
    );
};

export default FeeDetails;